import { render, staticRenderFns } from "./coachAssessment.vue?vue&type=template&id=2496252c&scoped=true"
import script from "./coachAssessment.vue?vue&type=script&lang=js"
export * from "./coachAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2496252c",
  null
  
)

export default component.exports